// eslint-disable-next-line no-unused-vars
import React, { useState } from "react";
import styles from "./DosingPatients.module.css";

const exampleLabels = [
  "65-year-old female with advanced breast cancer admitted for chemotherapy-induced febrile neutropenia, cough and profuse diarrhea:",
  "55-year-old male with history of hypertension, obesity, type 2 diabetes mellitus and hypercholesterolemia admitted with a non-ST-segment elevation myocardial infarction:",
  "45-year-old previously healthy female admitted with severe acute respiratory distress syndrome secondary to influenza A and bilateral pneumonia:",
];

const exampleContent = [
  [
    "Presents with acute kidney injury (AKI); serum creatinine was 3.72 mg/dL (baseline of 1.0 mg/dL)",
    `Absolute neutrophil count was 1,200 cells/mm<span class=${styles.superScript}>3</span>`,
    "Echocardiogram confirmed normal left-ventricular size and function",
    "Vancomycin and piperacillin/tazobactam were started",
    "Received 3 liters of IV fluid and MAP was 60 mm Hg",
    "Progressed to respiratory failure and required vasopressor support",
    "Despite adequate fluid resuscitation, the target MAP was not achieved; norepinephrine at 0.08 mcg/kg/min was initiated",
    "2 hours after norepinephrine initiation, MAP was 52 mm Hg and norepinephrine was titrated up to 0.2 mcg/kg/min; 15 minutes later MAP was 53 mm Hg",
  ],
  [
    "Patient had a left ventricular ejection fraction of 18% and was diagnosed with triple-vessel disease",
    "Patient underwent coronary artery bypass grafting and, after transitioning off cardiopulmonary bypass, developed distributive shock characterized by severe hypotension and vasoplegia with MAP of 56 mm Hg",
    `Post-operative cardiac index was 2.4 L/min/m<span class=${styles.superScript}>2</span>   and hemoglobin was 8.5 g/dL`,
    "Received norepinephrine at 0.23 mcg/kg/min, vasopressin at 0.06 units/min and methylene blue",
    "Remained severely hypotensive despite requiring a norepinephrine-equivalent dose of 0.41 mcg/kg/min",
  ],
  [
    "Quickly developed septic shock and was transferred to the ICU",
    "MAP was 58 mm Hg at ICU admission; intubation and mechanical ventilation were required",
    `Hemodynamic monitoring demonstrated euvolemia and a cardiac index of 3.6 L/min/m<span class=${styles.superScript}>2</span>`,
    "Despite adequate volume resuscitation, norepinephrine and vasopressin, target MAP of 65 mm Hg was not achieved on a norepinephrine-equivalent dose of 0.2 mcg/kg/min",
  ],
];

export default function DosingPatients({ defaultActive }) {
  const [activeExample, setActiveExample] = useState(defaultActive || 0);

  return (
    <div>
      <div className={styles.patientsTableHeader}>
        <div
          className={`${styles.patientsTableTab} ${
            activeExample === 0 ? styles.activeTab : null
          }`}
          onClick={() => setActiveExample(0)}
        >
          {activeExample === 0 ? <div className={styles.arrow}></div> : null}
          <span>Septic Shock Patient with AKI</span>
        </div>
        <div
          className={`${styles.patientsTableTab} ${
            activeExample === 1 ? styles.activeTab : null
          }`}
          onClick={() => setActiveExample(1)}
        >
          {activeExample === 1 ? <div className={styles.arrow}></div> : null}
          <span>
            Post Cardiac Surgery Patient with Distributive Shock (Vasoplegia)
          </span>
        </div>
        <div
          className={`${styles.patientsTableTab} ${
            activeExample === 2 ? styles.activeTab : null
          }`}
          onClick={() => setActiveExample(2)}
        >
          {activeExample === 2 ? <div className={styles.arrow}></div> : null}
          <span>Septic Shock Patient with Severe Influenza</span>
        </div>
      </div>
      {activeExample !== null ? (
        <div className={styles.patientsTable}>
          <div className={styles.patientLabel}>
            {exampleLabels[activeExample]}
          </div>
          <div className={styles.patientsContent}>
            <ul>
              {exampleContent[activeExample].map((example, i) => {
                return (
                  <li
                    dangerouslySetInnerHTML={{ __html: example }}
                    key={i}
                  ></li>
                );
              })}
            </ul>
            <div className={styles.tableDisclaimer}>
              This is not based on an actual patient. Patient profile is for
              illustrative purposes only and does not constitute treatment
              advice.
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
